<h1 mat-dialog-title>Setup Answers</h1>



<div mat-dialog-content style="display: flex;flex-direction: column;">

  <div class="example-full-width" style="display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;margin-top: 12px;margin-bottom: 20px;">
    <mat-label style="font-weight: bold;" class="get-label">{{Title}}</mat-label>
    <span style="color: lightgray;">{{QuestionTypeTitle}}</span>
  </div>

  <div *ngIf="data.QuestionTypeId == 1">
    <!-- true-false -->
    <div style="display: flex;justify-content: space-between;align-items: center;">
      <span>Option One</span>
      <mat-form-field class="header-form-full-width">
        <input placeholder="Option One" matInput type="text" matInput [(ngModel)]="AnswerOptionOne" class="get-Input">
      </mat-form-field>
    </div>

    <div style="display: flex;justify-content: space-between;margin-top: 6px;align-items: center;">
      <span>Option Two</span>
      <mat-form-field class="header-form-full-width">
        <input placeholder="Option Two" matInput type="text" matInput [(ngModel)]="AnswerOptionTwo" class="get-Input">
      </mat-form-field>

    </div>
  </div>

  <div *ngIf="data.QuestionTypeId == 2">
    <!-- multiple-choice -->
    
      <mat-list role="list" *ngFor="let f of MultipleChoiceAnswerList">
        <mat-list-item  role="listitem" style="display: flex;
        flex-direction: column">
          <div style="display: flex;flex-direction: row;flex:1;justify-content: space-between;">
            <span>{{f.name}}</span>
            <i (click)="OnclickDeleteOption(f)" class="material-icons button__icon"
              style="color:red;cursor: pointer;margin-right: 20px;">delete</i>
          </div>
        </mat-list-item>
      </mat-list>
    

    <div style="display: flex;flex-direction: row;justify-content: space-between;">
      <div style="display: flex;flex: 2;">
        <mat-form-field class="header-form-full-width">
          <input placeholder="Answer" matInput type="text" matInput [(ngModel)]="Answer" class="get-Input">
        </mat-form-field>

      </div>
      <div style="display: flex;flex: 1;">
        <button class="button button--primary" style="margin-left: 20px;width: 200px;align-self: flex-end;"
          (click)="onClickAddAnswer()">
          <span class="button__text">+ Add Answer</span>
        </button>
      </div>

    </div>
  </div>

  <div *ngIf="data.QuestionTypeId == 3">
    <!-- multiple-answer -->
    
      <mat-list role="list" *ngFor="let f of MultipleSelectionAnswerList">
        <mat-list-item  role="listitem" style="display: flex;
        flex-direction: column">
          <div style="display: flex;flex-direction: row;flex:1;justify-content: space-between;">
            <span>{{f.name}}</span>
            <i (click)="OnclickDeleteOptionMultipleSel(f)" class="material-icons button__icon"
              style="color:red;cursor: pointer;margin-right: 20px;">delete</i>
          </div>
        </mat-list-item>
      </mat-list>
  

    <div style="display: flex;flex-direction: row;justify-content: space-between;">
      <div style="display: flex;flex: 2;">
        <mat-form-field class="header-form-full-width">
          <input placeholder="Answer" style="width: 500px;" type="text" matInput [(ngModel)]="Answer" class="get-Input">
        </mat-form-field>
      </div>
      <div style="display: flex;flex: 1;">
        <button class="button button--primary" style="margin-left: 20px;width: 200px;align-self: flex-end;"
          (click)="onClickAddAnswerMultipleSel()">
          <span class="button__text">+ Add Answer</span>
        </button>
      </div>

    </div>
  </div>

</div>

<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
  <button style="margin-left: 20px;" class="button button--primary" (click)="onSubmitClick()" cdkFocusInitial><span
      class="button__text">Submit</span></button>
</div>